<div [formGroup]="form" class="flex flex-col gap-4">
  <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
    @for (attr of attributes(); track attr.attributeKey.titleEn) {
      <div class="flex flex-col gap-2">
        <label class="text-sm font-bold text-gray-700">
          {{ getLabel(attr.attributeKey) }}
        </label>
        <div class="relative">
          <select
            [formControlName]="attr.attributeKey.titleEn ?? ''"
            class="w-full cursor-pointer appearance-none rounded-xl border bg-white p-3 pe-9 text-sm transition-all outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-50 disabled:bg-gray-100"
            [class.border-red-400]="duplicateError()"
            [class.border-gray-300]="!duplicateError()">
            <option value="">
              @if (isArabic()) {
                اختر {{ attr.attributeKey.titleAr || attr.attributeKey.titleEn }}
              } @else {
                Select {{ attr.attributeKey.titleEn }}
              }
            </option>
            @for (val of attr.attributeValues; track val.id) {
              <option [value]="val.id">{{ getLabel(val) }}</option>
            }
          </select>
          <app-dropdown-arrow [isArabic]="isArabic()" />
        </div>
        @if (
          form.get(attr.attributeKey.titleEn ?? "")?.touched &&
          form.get(attr.attributeKey.titleEn ?? "")?.errors?.["required"]
        ) {
          <p class="text-[10px] text-red-500">
            @if (isArabic()) {
              هذا الحقل مطلوب
            } @else {
              This field is required
            }
          </p>
        }
      </div>
    }
  </div>

  @if (duplicateError()) {
    <p class="mt-2 text-xs text-red-500">
      @if (isArabic()) {
        يوجد بالفعل منتج فرعي بنفس المواصفات المختارة.
      } @else {
        A sub-product with this combination of attributes already exists
      }
    </p>
  }
</div>
